import { useEffect } from 'react'
import { inject, observer } from 'mobx-react'
import { FormattedMessage, WrappedComponentProps, injectIntl } from 'react-intl'
import './SimulatedAtsNewReportDone.scss'
import { Elements, TextButton } from '@tfo/common'
import RootStore from '../../../../../stores/RootStore'
import { useStore } from '../../../../../hooks/useStore'


const { Heading1, Paragraph } = Elements

export interface NewReportDoneProps {
	rootStore?: RootStore
}

const NewReportDone = (props: NewReportDoneProps & WrappedComponentProps) => {
	const { clientViewStore } = useStore()

	const sendMessageToExternalIframe = () => {
		const message = JSON.stringify({
			message: 'tfo.orderComplete',
		});
		// Target origin set to *, because we don't have the url to the parent component provider
		window.parent.postMessage(message, '*');
	}

	useEffect(() => {
		clientViewStore.toggleExternalHostedOrderFlow(true)
	}, [])

	return (
		<div className="simulatedOrder-wrapper">
			<Heading1>
				Detta är en simulerad beställningsbekräftelse.
			</Heading1>
			<Paragraph className={'NewReportDone__BlockSpace--medium'}>
				<span>
					<FormattedMessage id={'neworder.done.body.row1'} />
				</span>
				<span>
					<FormattedMessage id={'neworder.done.body.row2'} />
				</span>
				<span>
					<FormattedMessage id={'neworder.done.body.row3'} />
				</span>
				<span>
					<FormattedMessage id={'neworder.done.body.row4'} />
				</span>
			</Paragraph>
			<TextButton
				className={'NewReportDone__BlockSpace--big'}
				onClick={() => sendMessageToExternalIframe()}>
				<FormattedMessage id={'neworder.done.cta'} />
			</TextButton>
		</div>
	)
}

export default injectIntl(inject('rootStore')(observer(NewReportDone)))
